import { HeartPulse, PhoneCall, Pill, Siren, Users, Hospital, Flame } from "lucide-react";

export const IMAGES = {
  heroPortrait:
    "https://images.unsplash.com/photo-1749189516333-168cfd97de0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBzZW5pb3IlMjBzbWlsaW5nfGVufDB8fHx8MTc4Nzc4NzU5MHww&ixlib=rb-4.1.0&q=85",
  bpCheck:
    "https://images.unsplash.com/photo-1758691462413-b07dee2933fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBzZW5pb3IlMjBjaXRpemVuJTIwYmxvb2QlMjBwcmVzc3VyZSUyMGNoZWNrdXB8ZW58MHx8fHwxNzg3Nzg3NjQ3fDA&ixlib=rb-4.1.0&q=85",
  videoCall:
    "https://images.unsplash.com/photo-1560885673-4e2f056f6e2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBlbGRlcmx5JTIwdmlkZW8lMjBjYWxsJTIwZmFtaWx5fGVufDB8fHx8MTc4Nzc4NzY0N3ww&ixlib=rb-4.1.0&q=85",
  meetup:
    "https://images.unsplash.com/photo-1769618097083-48516fc6e23a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBzZW5pb3IlMjBjaXRpemVucyUyMGdyb3VwJTIwbWVldHVwJTIwaGFwcHl8ZW58MHx8fHwxNzg3Nzg3NjQ3fDA&ixlib=rb-4.1.0&q=85",
  medicine:
    "https://images.unsplash.com/photo-1563213126-a4273aed2016?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxtZWRpY2luZSUyMHBpbGxzJTIwb3JnYW5pemVyJTIwZWxkZXJseSUyMGNhcmV8ZW58MHx8fHwxNzg3Nzg3NjQ3fDA&ixlib=rb-4.1.0&q=85",
  caregiver:
    "https://images.unsplash.com/photo-1762955911431-4c44c7c3f408?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxjYXJlZ2l2ZXIlMjBzZW5pb3J8ZW58MHx8fHwxNzg3Nzg3NTkwfDA&ixlib=rb-4.1.0&q=85",
  jaipur:
    "https://images.unsplash.com/photo-1706961121783-4ae6c933983a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxqYWlwdXIlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg3Nzg3NTkwfDA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "bp",
    price: "From ₹499 / visit",
    label: "BP & Vitals Check",
    title: "Blood pressure & vitals, at home",
    desc: "A trained representative visits and records blood pressure, pulse and general wellbeing — logged and shared with you.",
    icon: HeartPulse,
    image: IMAGES.bpCheck,
  },
  {
    id: "call",
    price: "Included with every visit",
    label: "Call With You",
    title: "A live call the moment we arrive",
    desc: "As soon as our representative reaches your parents' home, we connect a video or voice call so you can see them and speak, wherever you are.",
    icon: PhoneCall,
    image: IMAGES.videoCall,
  },
  {
    id: "medicine",
    price: "From ₹299 + medicines",
    label: "Medicine Support",
    title: "Medicines, delivered & organised",
    desc: "We arrange the medicines your parents need, set up their weekly dispenser and gently remind them to take each dose.",
    icon: Pill,
    image: IMAGES.medicine,
  },
  {
    id: "emergency",
    price: "₹999 / month",
    label: "Emergency Response",
    title: "Someone to attend, whenever needed",
    desc: "A dedicated line and a nearby representative ready to attend to your parents during an emergency — day or night.",
    icon: Siren,
    image: IMAGES.caregiver,
  },
  {
    id: "meetup",
    price: "₹1,499 / month",
    label: "Weekly Meetups",
    title: "Company, every single week",
    desc: "Regular home visits and community meetups so your parents are never alone — conversation, warmth and familiar faces.",
    icon: Users,
    image: IMAGES.meetup,
  },
  {
    id: "hospital",
    price: "From ₹899 / trip",
    label: "Hospital Visits",
    title: "We accompany them to the hospital",
    desc: "Request a representative to escort your parents to hospital check-ups and appointments — on the date and time you choose. Safe travel, queues handled, and updates back to you.",
    icon: Hospital,
    image: IMAGES.bpCheck,
  },
  {
    id: "cremation",
    label: "Cremation & Last Rites",
    title: "A dignified final farewell",
    desc: "In the hardest moments, we stand by your family — respectfully coordinating cremation and last-rites rituals with dignity and care when you cannot be present.",
    icon: Flame,
    image: IMAGES.caregiver,
  },
];

export const CONSULTANT_PHONE = "+91 90000 24240";
export const CONSULTANT_PHONE_TEL = "+919000024240";

export const VISIT_PLANS = [
  {
    id: "v1",
    name: "Single Visit",
    desc: "One home visit — vitals check, live call to you, and a full update on how they are.",
    price: 2500,
    was: 3500,
    unit: "per visit",
  },
  {
    id: "v2",
    name: "Two Visits",
    desc: "Two home visits — perfect for a regular fortnightly check-in on your parents.",
    price: 4500,
    was: 6000,
    unit: "for 2 visits",
  },
  {
    id: "v4",
    name: "Monthly Care",
    desc: "Four visits every month — our most-loved plan for consistent, ongoing care.",
    price: 6000,
    was: 8000,
    unit: "per month",
    popular: true,
  },
];

export const URGENT_PLANS = [
  {
    id: "day",
    name: "Emergency Visit",
    desc: "Rapid daytime response when your parents need us urgently.",
    time: "9:30 AM – 6:00 PM",
    price: 3500,
    was: 5000,
    unit: "per visit",
  },
  {
    id: "night",
    name: "Night Visit",
    desc: "Overnight emergency care and attendance, through the night.",
    time: "6:00 PM – 9:30 AM",
    price: 5000,
    was: 10000,
    unit: "per visit",
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.label);

export const TIME_SLOTS = [
  "08:00 – 10:00 AM",
  "10:00 – 12:00 PM",
  "12:00 – 02:00 PM",
  "02:00 – 04:00 PM",
  "04:00 – 06:00 PM",
  "06:00 – 08:00 PM",
];

export const FREQUENCIES = ["Every week", "2 days a month", "4 days a month"];
export const EXPERTISE_DOMAINS = [
  "General Physician",
  "Cardiology",
  "Orthopedics",
  "Neurology",
  "Diabetology / Endocrine",
  "Gynaecology",
  "ENT",
  "Ophthalmology (Eye)",
  "Dermatology (Skin)",
  "Urology",
  "Physiotherapy",
  "Other",
];
export const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const MONTH_DAYS = Array.from({ length: 28 }, (_, i) => String(i + 1));

export const FAQS = [
  {
    q: "Which areas do you serve?",
    a: "We currently serve families across Jaipur. Tell us your parents' locality when you request a visit and we'll confirm coverage.",
  },
  {
    q: "Do you need my permission to visit my parents?",
    a: "Always. No representative ever enters a home without the family's consent — you approve every visit, and you can withdraw consent any time.",
  },
  {
    q: "What happens during a home visit?",
    a: "Our representative checks blood pressure and sugar, notes general wellbeing, helps with medicines, and connects a live call so you can see and speak with your parents. You receive a summary with photos after each visit.",
  },
  {
    q: "How do I get updates if I live in another city or country?",
    a: "We call you the moment we arrive, and send a visit summary with BP/sugar readings and photos to your email — so you always know how your parents are doing.",
  },
  {
    q: "Can you take my parents to the hospital?",
    a: "Yes. You can request hospital accompaniment for check-ups on a date and time you choose, and use 'Emergency help now' for urgent situations.",
  },
  {
    q: "How do I get started?",
    a: "Tap 'Request a visit', share a few details and give your consent. Our Jaipur team will call you to confirm the schedule.",
  },
];


export const STEPS = [
  {
    n: "01",
    title: "You request a visit",
    body: "Tell us about your parents in Jaipur, choose the care they need and pick a date and time slot that suits them.",
  },
  {
    n: "02",
    title: "You give your consent",
    body: "As their child, you formally approve our representative visiting the home. No visit ever happens without your permission.",
  },
  {
    n: "03",
    title: "We visit & call you",
    body: "Our representative reaches the home, checks their vitals, and connects a live call so you can see and speak to your parents.",
  },
  {
    n: "04",
    title: "We stay in touch",
    body: "You receive a summary after every visit — vitals, medicines, and how they're doing. Care that continues, week after week.",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Distance should never mean absence.",
    body: "Your career took you to another city, another country. Ours is the hand that reaches your parents when yours can't. We stand in the gap — gently, reliably.",
  },
  {
    n: "02",
    title: "Care begins with permission.",
    body: "We never step into a home without the family's blessing. Every visit is approved by you, the child, so trust is never assumed — it is given.",
  },
  {
    n: "03",
    title: "Dignity is the whole point.",
    body: "Not clinical, not cold. We treat every elder as we would our own mother and father — with patience, respect and unhurried attention.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I live in Toronto. Every Thursday I get a call the moment they reach Maa's home. Seeing her smile on that screen is the best part of my week.",
    name: "Rohan Mehta",
    role: "Son · Toronto",
  },
  {
    quote:
      "They noticed Papa's BP was high and got his medicines sorted the same day. It's like having family in Jaipur when we can't be there.",
    name: "Anjali Sharma",
    role: "Daughter · Bengaluru",
  },
];
